import moment from 'moment';
import { CoachStatistics } from '../../../shared/model/coach-statistics.model';
import { UserService } from '../../../core/user/user.service';
import { FormControl } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertModalComponent } from '../../../shared/alert/alert-modal.component';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/user/user.service";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../ng-jhipster/language";
import * as i4 from "@angular/common";
import * as i5 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "@angular/material/form-field";
import * as i7 from "@angular/material/input";
import * as i8 from "@angular/material/datepicker";
import * as i9 from "@angular/forms";
import * as i10 from "@angular/material/icon";
function MyStatisticsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelement(3, "h6", 5);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵelementStart(6, "mat-form-field", 8);
    i0.ɵɵelementStart(7, "mat-label", 9);
    i0.ɵɵtext(8, "Select a start date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 10);
    i0.ɵɵlistener("click", function MyStatisticsComponent_div_1_Template_input_click_9_listener() { i0.ɵɵrestoreView(_r6); const _r1 = i0.ɵɵreference(14); return _r1.open(); })("dateInput", function MyStatisticsComponent_div_1_Template_input_dateInput_9_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onStartDatePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "mat-datepicker-toggle", 11);
    i0.ɵɵelementStart(11, "mat-icon", 12);
    i0.ɵɵtext(12, "calendar_month");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "mat-datepicker", null, 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 14);
    i0.ɵɵelementStart(16, "mat-form-field", 8);
    i0.ɵɵelementStart(17, "mat-label", 15);
    i0.ɵɵtext(18, "Select an end date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "input", 10);
    i0.ɵɵlistener("click", function MyStatisticsComponent_div_1_Template_input_click_19_listener() { i0.ɵɵrestoreView(_r6); const _r2 = i0.ɵɵreference(24); return _r2.open(); })("dateInput", function MyStatisticsComponent_div_1_Template_input_dateInput_19_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.onEndDatePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "mat-datepicker-toggle", 11);
    i0.ɵɵelementStart(21, "mat-icon", 12);
    i0.ɵɵtext(22, "calendar_month");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(23, "mat-datepicker", null, 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 17);
    i0.ɵɵelementStart(26, "div", 18);
    i0.ɵɵelementStart(27, "div", 19);
    i0.ɵɵelement(28, "h4", 20);
    i0.ɵɵelementStart(29, "h4");
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 21);
    i0.ɵɵelement(32, "h4", 22);
    i0.ɵɵelementStart(33, "h4");
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 23);
    i0.ɵɵelementStart(36, "div", 19);
    i0.ɵɵelement(37, "h4", 24);
    i0.ɵɵelementStart(38, "h4");
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 21);
    i0.ɵɵelement(41, "h4", 25);
    i0.ɵɵelementStart(42, "h4");
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 26);
    i0.ɵɵelementStart(45, "div", 4);
    i0.ɵɵelement(46, "h6", 5);
    i0.ɵɵelementStart(47, "div");
    i0.ɵɵelementStart(48, "div", 27);
    i0.ɵɵelementStart(49, "mat-form-field", 8);
    i0.ɵɵelementStart(50, "mat-label", 9);
    i0.ɵɵtext(51, "Select a start date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "input", 10);
    i0.ɵɵlistener("click", function MyStatisticsComponent_div_1_Template_input_click_52_listener() { i0.ɵɵrestoreView(_r6); const _r3 = i0.ɵɵreference(57); return _r3.open(); })("dateInput", function MyStatisticsComponent_div_1_Template_input_dateInput_52_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onStartDatePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "mat-datepicker-toggle", 11);
    i0.ɵɵelementStart(54, "mat-icon", 12);
    i0.ɵɵtext(55, "calendar_month");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(56, "mat-datepicker", null, 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "div", 27);
    i0.ɵɵelementStart(59, "mat-form-field", 8);
    i0.ɵɵelementStart(60, "mat-label", 15);
    i0.ɵɵtext(61, "Select an end date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "input", 10);
    i0.ɵɵlistener("click", function MyStatisticsComponent_div_1_Template_input_click_62_listener() { i0.ɵɵrestoreView(_r6); const _r4 = i0.ɵɵreference(67); return _r4.open(); })("dateInput", function MyStatisticsComponent_div_1_Template_input_dateInput_62_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onEndDatePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "mat-datepicker-toggle", 11);
    i0.ɵɵelementStart(64, "mat-icon", 12);
    i0.ɵɵtext(65, "calendar_month");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(66, "mat-datepicker", null, 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "div", 30);
    i0.ɵɵelementStart(69, "div", 31);
    i0.ɵɵelementStart(70, "div", 19);
    i0.ɵɵelement(71, "h4", 20);
    i0.ɵɵelementStart(72, "h4");
    i0.ɵɵtext(73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(74, "div", 21);
    i0.ɵɵelement(75, "h4", 22);
    i0.ɵɵelementStart(76, "h4");
    i0.ɵɵtext(77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "div", 32);
    i0.ɵɵelementStart(79, "div", 19);
    i0.ɵɵelement(80, "h4", 24);
    i0.ɵɵelementStart(81, "h4");
    i0.ɵɵtext(82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(83, "div", 21);
    i0.ɵɵelement(84, "h4", 25);
    i0.ɵɵelementStart(85, "h4");
    i0.ɵɵtext(86);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(14);
    const _r2 = i0.ɵɵreference(24);
    const _r3 = i0.ɵɵreference(57);
    const _r4 = i0.ɵɵreference(67);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("matDatepicker", _r1)("formControl", ctx_r0.startFormControl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r1);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("matDatepicker", _r2)("formControl", ctx_r0.endFormControl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r2);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.sessionsBooked);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.sessionsDone);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.clientNoShow);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.yourNoShow);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("matDatepicker", _r3)("formControl", ctx_r0.startFormControl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r3);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("matDatepicker", _r4)("formControl", ctx_r0.endFormControl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r4);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.sessionsBooked);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.sessionsDone);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.clientNoShow);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.coachStatistics.yourNoShow);
} }
export class MyStatisticsComponent {
    constructor(userService, modalService, languageService) {
        this.userService = userService;
        this.modalService = modalService;
        this.languageService = languageService;
        this.coachStatistics = new CoachStatistics();
        this.startDate = moment().startOf('week').add(1, 'day');
        this.endDate = moment().startOf('week').add(8, 'day');
        this.startFormControl = new FormControl(this.startDate.toDate());
        this.endFormControl = new FormControl(this.endDate.toDate());
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
    }
    ngOnInit() {
        this.userService.current().subscribe(user => {
            this.currentCoach = user;
            this.coachStatistics.coachId = this.currentCoach.id;
            this.renderStatistics(this.startDate, this.endDate);
        });
    }
    renderStatistics(startOfWeek, endOfWeek) {
        this.coachStatistics.startDate = startOfWeek;
        this.coachStatistics.endDate = endOfWeek;
        this.userService.getCoachStatistics(this.coachStatistics).subscribe(response => {
            this.coachStatistics = response;
            console.log(this.coachStatistics);
        }, error => {
            console.log(error);
        });
    }
    onStartDatePickerChange(event) {
        if (this.dateCheck(event.value, this.endDate.toDate())) {
            this.startFormControl = new FormControl(event.value);
            this.startDate = moment(event.value);
            this.renderStatistics(this.startDate, this.endDate);
        }
        else {
            this.startFormControl = new FormControl(this.startDate.toDate());
        }
    }
    onEndDatePickerChange(event) {
        if (this.dateCheck(this.startDate.toDate(), event.value)) {
            this.endFormControl = new FormControl(event.value);
            this.endDate = moment(event.value);
            this.renderStatistics(this.startDate, this.endDate);
        }
        else {
            this.endFormControl = new FormControl(this.endDate.toDate());
        }
    }
    dateCheck(start, end) {
        if (start >= end) {
            this.openAlertModal('inukaNgApp.coachStatistics.startBeforeEnd');
            return false;
        }
        else {
            return true;
        }
    }
    openAlertModal(message) {
        const modalRef = this.modalService.open(AlertModalComponent, this.modalOptions);
        modalRef.componentInstance.alertModalRef = modalRef;
        modalRef.componentInstance.language = this.languageService.getCurrentLanguage();
        modalRef.componentInstance.userAlertMessage = message;
    }
}
MyStatisticsComponent.ɵfac = function MyStatisticsComponent_Factory(t) { return new (t || MyStatisticsComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.JhiLanguageService)); };
MyStatisticsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MyStatisticsComponent, selectors: [["my-statistics"]], decls: 2, vars: 1, consts: [[1, "olha-theme"], ["class", "container", 4, "ngIf"], [1, "container"], [1, "d-none", "d-sm-block"], [1, "card", "coach-statistics-body"], ["jhiTranslate", "inukaNgApp.coachStatistics.yourStatistics", 1, "component-header"], [1, "row"], [1, "col-6", "datepicker-div", 2, "padding-right", "10px", "padding-left", "0"], ["appearance", "outline", 2, "width", "100%"], ["jhiTranslate", "inukaNgApp.coachStatistics.startDate"], ["placeholder", "mm/dd/yyyy", "matInput", "", "readonly", "", 3, "matDatepicker", "formControl", "click", "dateInput"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", ""], ["startPicker", ""], [1, "col-6", "datepicker-div", 2, "padding-left", "10px", "padding-right", "0"], ["jhiTranslate", "inukaNgApp.coachStatistics.endDate"], ["endPicker", ""], [1, "row", "statistics-row"], [1, "col-6", "statistics-div", 2, "border-right", "1px solid #CCE9E0"], [1, "d-flex", "justify-content-between", 2, "padding-bottom", "20px"], ["jhiTranslate", "inukaNgApp.coachStatistics.sessionsBooked"], [1, "d-flex", "justify-content-between"], ["jhiTranslate", "inukaNgApp.coachStatistics.sessionsDone"], [1, "col-6", "statistics-div"], ["jhiTranslate", "inukaNgApp.coachStatistics.clientNoShows"], ["jhiTranslate", "inukaNgApp.coachStatistics.yourNoShows"], [1, "d-sm-none"], [1, "datepicker-div"], ["startPickerMobile", ""], ["endPickerMobile", ""], [1, "statistics-row"], [1, "statistics-div", 2, "border-bottom", "1px solid #CCE9E0"], [1, "statistics-div"]], template: function MyStatisticsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MyStatisticsComponent_div_1_Template, 87, 20, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.coachStatistics);
    } }, directives: [i4.NgIf, i5.JhiTranslateDirective, i6.MatFormField, i6.MatLabel, i7.MatInput, i8.MatDatepickerInput, i9.DefaultValueAccessor, i9.NgControlStatus, i9.FormControlDirective, i8.MatDatepickerToggle, i6.MatSuffix, i10.MatIcon, i8.MatDatepickerToggleIcon, i8.MatDatepicker], styles: [".olha-theme[_ngcontent-%COMP%]{background-color:#f7f4eb;height:100%}.coach-statistics-body[_ngcontent-%COMP%]{height:auto;margin-top:30px;padding:30px 40px}.padding-none[_ngcontent-%COMP%]{padding-left:0 !important;padding-right:0 !important}fa-icon[_ngcontent-%COMP%]{font-size:25px}.row[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.datepicker-div[_ngcontent-%COMP%]{vertical-align:middle}.statistics-row[_ngcontent-%COMP%]{border:1px solid #cce9e0;border-radius:8px}.statistics-div[_ngcontent-%COMP%]{padding:20px}.component-header[_ngcontent-%COMP%]{font-family:\"Poppins\",sans-serif;font-style:normal;font-weight:700;font-size:25px;line-height:130%;color:#0a4a3a;margin-bottom:30px}.mat-icon[_ngcontent-%COMP%]{color:#44a38b}[_nghost-%COMP%]  .mat-radio-button, [_nghost-%COMP%]  .mat-form-field, [_nghost-%COMP%]  .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]  .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]  .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}@media(min-width: 576px){.coach-statistics-body[_ngcontent-%COMP%]{margin-top:50px;padding:30px 40px}}"] });
